import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Camila R.',
  location: 'Buenos Aires',
  text: 'Desde la primera noche dormí mejor. Las técnicas son simples y funcionan de verdad.',
  time: 'Hace 3 días'
}, {
  name: 'Martín G.',
  location: 'Córdoba',
  text: 'Mi mente no paraba nunca. Con el Tomo 2 aprendí a frenar los pensamientos en el momento. Increíble.',
  time: 'Hace 1 semana'
}, {
  name: 'Lucía P.',
  location: 'Rosario',
  text: 'Lo mejor que compré en mucho tiempo. Las plantillas terapéuticas son oro puro.',
  time: 'Hace 5 días'
}, {
  name: 'Federico M.',
  location: 'Mendoza',
  text: 'Pensé que era más teoría, pero es 100% práctico. Ya noto cambios reales en cómo manejo la ansiedad.',
  time: 'Hace 2 días'
}, {
  name: 'Valentina S.',
  location: 'CABA',
  text: 'Las rutinas de calma mental me salvaron en una crisis de ansiedad. No puedo creer que no conocía esto antes.',
  time: 'Hace 4 días'
}, {
  name: 'Diego L.',
  location: 'La Plata',
  text: 'Mi psicóloga me dijo que es un excelente complemento. Lo recomiendo totalmente.',
  time: 'Hace 1 semana'
}];
function Stars() {
  return <div className="flex gap-0.5" data-id="element-123">
      {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-orange text-orange" data-id="element-124" />)}
    </div>;
}
export function Reviews() {
  return <AnimatedSection className="bg-cream text-navy py-12 md:py-16" data-id="element-125">
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-center mb-3" data-id="element-126">
        ⭐ Lo que dicen quienes ya lo tienen
      </h2>
      <p className="text-center text-navy-light text-sm mb-8" data-id="element-127">
        +5,790 personas transformando su salud mental
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-128">
        {reviews.map((review, idx) => <div key={idx} className="bg-white rounded-xl p-5 shadow-sm border border-orange/10" data-id="element-129">
            <Stars data-id="element-130" />
            <p className="text-sm text-navy mt-3 mb-4 leading-relaxed" data-id="element-131">
              "{review.text}"
            </p>
            <div className="flex items-center justify-between" data-id="element-132">
              <div data-id="element-133">
                <p className="font-heading font-bold text-sm text-navy" data-id="element-134">
                  {review.name}
                </p>
                <p className="text-xs text-gray-400" data-id="element-135">{review.location}</p>
              </div>
              <span className="text-xs text-gray-400" data-id="element-136">{review.time}</span>
            </div>
          </div>)}
      </div>
    </AnimatedSection>;
}